import { TextField, MenuItem } from "@material-ui/core"

export default function Referrer() {
  return (
    <fieldset>
      <legend className="quoteform__heading">Where did you hear about us?</legend>
      <div className="quoteform__grid">
          <div className="quoteform__input">
              <TextField name="referral-code-dropdown" select fullWidth label="Referral" variant="outlined">
                  <MenuItem value=""></MenuItem>
                  <MenuItem value="thedis">The DIS</MenuItem>
                  <MenuItem value="mydvcpoints">My DVC Points Podcast</MenuItem>
                  <MenuItem value="dvcfan">DVC Fan</MenuItem>
                  <MenuItem value="welcomehome">Welcome Home Podcast</MenuItem>
                  <MenuItem value="WODshow">World of DVC Show</MenuItem>
                  <MenuItem value="disneynerds">Disney Nerds</MenuItem>
                  <MenuItem value="wdwmagic">WDW Magic</MenuItem>
                  <MenuItem value="social-media">Social Media</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
              </TextField>
          </div>
      </div>
  </fieldset>
  )
}


// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanApplication/components/Referrer.js